<section class="pss-page">
  <div class="page-shell">
    <a routerLink="/register" class="crumb">Select Stakeholder <span>›</span> PSS Owner Registration</a>

    <header class="hero">
      <div class="hero-left">
        <button type="button" class="back-btn" routerLink="/register">←</button>
        <div>
          <h1>PSS Owner Registration</h1>
          <p>Pooling Sub-Station Owner - Fill in all required fields and submit. Your request will be sent to MSLDC Admin for approval.</p>
        </div>
      </div>
      <div class="hero-pill">No login required</div>
    </header>

    <form class="form-stack" [formGroup]="form" (ngSubmit)="submit()">
      <section class="panel">
        <div class="panel-head">PSS Owner Information</div>
        <div class="grid two">
          <label>
            <span>PSS Owner Name *</span>
            <input formControlName="pss_owner_name" placeholder="e.g. MSETCL - Kalwa Division">
          </label>
          <label>
            <span>Organization / Entity *</span>
            <input formControlName="organization_entity" placeholder="Full Organization Name">
          </label>
          <label>
            <span>PSS Name *</span>
            <input formControlName="pss_name" placeholder="e.g. Kalwa 220/110kV PSS">
          </label>
          <label>
            <span>PSS Code *</span>
            <input formControlName="pss_code" placeholder="e.g. KPSS220">
          </label>
          <label>
            <span>Voltage Level (kV) *</span>
            <select formControlName="voltage_level">
              <option value="">Select Voltage</option>
              <option>11</option>
              <option>33</option>
              <option>66</option>
              <option>110</option>
              <option>220</option>
              <option>400</option>
            </select>
          </label>
          <label>
            <span>Grid Interconnection Type *</span>
            <select formControlName="grid_interconnection_type">
              <option value="">Select Type</option>
              <option>Intra-state</option>
              <option>Inter-state</option>
              <option>Dedicated</option>
            </select>
          </label>
        </div>
      </section>

      <section class="panel">
        <div class="panel-head">PSS Location & Address</div>
        <div class="grid two">
          <label class="span-2">
            <span>Address Line 1 *</span>
            <input formControlName="address_line1" placeholder="Building / Plot No., Street">
          </label>
          <label>
            <span>Address Line 2</span>
            <input formControlName="address_line2" placeholder="Area / Locality">
          </label>
          <label>
            <span>City / Town *</span>
            <input formControlName="city_town" placeholder="e.g. Pune">
          </label>
          <label>
            <span>District *</span>
            <input formControlName="district" placeholder="Select District">
          </label>
          <label>
            <span>State *</span>
            <input formControlName="state" placeholder="Select State">
          </label>
          <label>
            <span>Pin Code *</span>
            <input formControlName="pin_code" placeholder="e.g. 411001">
          </label>
          <label>
            <span>Country *</span>
            <input formControlName="country" placeholder="India">
          </label>
        </div>
      </section>

      <section class="panel">
        <div class="panel-head">Contact Person Details</div>
        <div class="grid two">
          <label>
            <span>Contact Person Name *</span>
            <input formControlName="contact_person_name" placeholder="Full Name">
          </label>
          <label>
            <span>Designation</span>
            <input formControlName="designation" placeholder="e.g. Executive Engineer">
          </label>
          <label>
            <span>Mobile Number *</span>
            <input formControlName="mobile_number" placeholder="+91 98765 43210">
          </label>
          <label>
            <span>Email Address *</span>
            <input formControlName="email_address" placeholder="contact@msetcl.gov.in" type="email">
          </label>
        </div>
      </section>

      <section class="panel">
        <div class="panel-head">Document Upload</div>
        <div class="upload-list">
          @for (document of documents; track document; let index = $index) {
            <div class="upload-card">
              <span class="upload-title">{{ document }} *</span>
              <input #fileInput type="file" multiple hidden (change)="onFilesSelected($event, index)">
              <button type="button" class="upload-box" (click)="openFilePicker(index)">
                <div class="upload-icon">⇪</div>
                <p>Drop files here or <strong>browse</strong></p>
                <small>PDF, JPG, PNG up to 10 MB each</small>
              </button>
              @if (uploadSlots[index].files.length > 0) {
                <div class="file-list">
                  @for (file of uploadSlots[index].files; track file.name) {
                    <span class="file-name">{{ file.name }}</span>
                  }
                </div>
              }
            </div>
          }
        </div>
      </section>

      <section class="panel declaration-panel">
        <div class="panel-head">Declaration</div>
        <div class="declaration">
          <p>
            I hereby declare that the information furnished above is true and correct to the best of my knowledge and belief.
            I understand that in the event of any information being found false or incorrect, my registration is liable to be
            cancelled without any notice.
          </p>
        </div>
        <label class="terms">
          <input type="checkbox" formControlName="declaration_accept">
          <span>I agree to the <strong>Terms & Conditions</strong> and <strong>Privacy Policy</strong> of the RE-DSM system.</span>
        </label>
      </section>

      @if (message) {
        <div class="toast-message" [class.error]="messageType === 'error'" role="status">
          {{ message }}
        </div>
      }

      <footer class="footer-actions">
        <div class="note">Fields marked * are mandatory. Your registration request will be sent to the MSLDC Admin for review. No login is required to submit.</div>
        <div class="actions">
          <a routerLink="/register" class="btn ghost">Cancel</a>
          <button type="button" class="btn ghost">Reset</button>
          <button type="submit" class="btn primary">Send Request to Admin</button>
        </div>
      </footer>
    </form>
  </div>
</section>

